import { render, staticRenderFns } from "./CartCheckout.vue?vue&type=template&id=10b580d9&scoped=true&"
import script from "./CartCheckout.vue?vue&type=script&lang=js&"
export * from "./CartCheckout.vue?vue&type=script&lang=js&"
import style0 from "./CartCheckout.vue?vue&type=style&index=0&id=10b580d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b580d9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VDialog,VRow,VSimpleTable,VSpacer,VSwitch,VTextField})
